import React from 'react';

export default class Diagram extends React.Component {

    constructor(props) {
        super(props);
        this.testPaths2 = [
            ["T1", "T2", "T3", "A1", "A2", "A3", "A4", "T4","T5","WB"],
            ["T1", "T2", "T3", "B1", "B2", "C1", "C2", "T4","T5","WB"],
            ["T1", "T2", "T3", "B3", "C1", "C2", "T4","T5","WB"],
            ["T1", "T2", "T3", "D1", "D2", "E1", "E2", "E3", "T4","T5","WB"],
            ["T1", "T2", "T3", "D1", "D2", "E4", "E5", "T4","T5","WB"],
            ["T1", "T2", "T3", "F1", "F2", "G1", "G2", "F3","F4"],
            ["T1", "T2", "T3", "F1", "F2", "G3", "G4", "F3","F4"],
            ["T1", "T2", "T3", "F1", "H1", "H2", "H3"],
        ];
        this.testPaths1 = [
            ["T1", "T2", "T3", "A1", "A2", "A3", "A4", "T4","T5","WB"],
            ["T1", "T2", "T3", "B1", "B2", "C1", "C2", "T4","T5","WB"],
        ];
        this.config = {
            phaseWidth: 40,
            phaseHeight: 50,
            regWidth: 16,
            regHeight: 60,
            phaseFont: { fontSize: "14px" },
            regFont: { fontSize: "10px" },
            connLength: 20,
            regConnLength: 5,
            rowGap: 5,
            branchWidth: 20,
            connStrokeProps: { stroke: "black", strokeWidth: "1" },
            phaseStrokeProps: { stroke: "black", strokeWidth: "1" },
            phaseColors: {IF: "#798fa8", ID: "#efdaa3", EX: "#4ec4a4", MEM: "#d03b40", WB: "#a09c9b"},
            regColor: "#eff0f1",
            latencyWidth: 10,
        };
        this.onThemeChanged = this.onThemeChanged.bind(this);
    }

    componentDidMount() {
        document.addEventListener("themeChange", this.onThemeChanged);
    }

    componentWillUnmount() {
        document.removeEventListener("themeChange", this.onThemeChanged);
    }

    onThemeChanged(event) {
        this.forceUpdate();
    }

    pipelineBoxRenderer(element) {
        let startPhaseRect = 0;
        let boxHeight = this.config.phaseHeight;
        let inputReg = <></>;
        if (element.input) { // has pipeline register before it
            inputReg = <>
                    <rect   x={0} y={-this.config.regHeight/2} 
                            width={this.config.regWidth} height={this.config.regHeight} 
                            {...this.config.phaseStrokeProps} fill={this.config.regColor} />
                    <line   x1={this.config.regWidth} y1={0} 
                            x2={this.config.regWidth+this.config.regConnLength} y2={0}
                            {...this.config.connStrokeProps} />
                    <text   x={this.config.regWidth/2} y={0} 
                            textAnchor="middle" dominantBaseline="central" transform={`rotate(-90, ${this.config.regWidth/2}, 0)`}
                            {...this.config.regFont} >
                                {element.input}
                    </text>
            </>;
            startPhaseRect += this.config.regWidth + this.config.regConnLength;
            boxHeight = Math.max(boxHeight, this.config.regHeight);
        }

        const thisPhaseWidth = Math.max(this.config.phaseWidth, element.latency*this.config.latencyWidth);

        const roles = element.role.split(",");        
        const phaseBg = roles.map( (val,ix) => 
                        <rect x={startPhaseRect} y={-this.config.phaseHeight/2 + ix*this.config.phaseHeight/roles.length} 
                            width={thisPhaseWidth} height={this.config.phaseHeight/roles.length}
                            stroke="none" fill={this.config.phaseColors[val]} key={ix} />);
        const lines = Array.from(Array(element.latency-1)).map((val,ix) => 
                        <line   x1={startPhaseRect + (ix+1)*thisPhaseWidth/element.latency} y1={-this.config.phaseHeight/2} 
                                x2={startPhaseRect + (ix+1)*thisPhaseWidth/element.latency} y2={this.config.phaseHeight/2} 
                                {...this.config.phaseStrokeProps} key={ix} />);
        const phase = <>
            {phaseBg}
            <rect   x={startPhaseRect} y={-this.config.phaseHeight/2} 
                            width={thisPhaseWidth} height={this.config.phaseHeight}
                            {...this.config.phaseStrokeProps} fill="none" />
            {lines}
            <text   x={startPhaseRect+thisPhaseWidth/2} y={0} 
                    textAnchor="middle" dominantBaseline="middle"
                    {...this.config.phaseFont} >
                        {element.label}
            </text>
        </>;

        return {
            g:  <g>
                    {inputReg}
                    {phase}
                </g>,
            h: boxHeight/2,
            d: boxHeight/2,
            w: startPhaseRect+thisPhaseWidth
        };
    }

    renderDiagram(paths, boxRenderer, endOfDiagram=true) {

        function getMergePoint(paths) {
            const firstPath = paths[0];
            if (firstPath.length === 0)
                return false;
            for(let p of firstPath) 
                if (paths.every(x => x.findIndex(e => e.label === p.label) > -1))  // e => _.isEqual(e, p)
                    return p;
            return false;
        }

        function splitPaths(paths, mergePoint) {
            if (mergePoint === false)
                return { first: paths, second: []};
            else {
                const firstPart = [];
                const secondPart = [];
                paths.forEach(x => {
                    const mpIx = x.findIndex(e => e.label === mergePoint.label); // e => _.isEqual(e, mergePoint)
                    if (mpIx === -1) {
                        firstPart.push(x);
                        secondPart.push([]);
                    }
                    else {
                        firstPart.push(x.slice(0, mpIx));
                        secondPart.push(x.slice(mpIx));
                    }
                });
                return { first: firstPart, second: secondPart };
            }
        }

        function groupConnectedPaths(paths) {
            const groups = [];
            for (let p of paths) {
                let hasCommonPoints = false;
                for (let g of groups)
                    if (p.some(x => g.some(y => y.findIndex(e => e.label === x.label) > -1))) { // e => _.isEqual(e, x)
                        g.push(p);
                        hasCommonPoints = true;
                        break;
                    }
                if (hasCommonPoints === false)
                    groups.push([p]);
            }
            return groups;
        }

        if (paths.length === 0)
            return { 
                g: <g></g>,
                w: 0,
                h: 0,
                d: 0,
                in: []
            }

        if (paths.every(x => x[0].label === paths[0][0].label)) { // _.isEqual(x[0], paths[0][0])
            // simple case, just draw a box and continue recursively
            const first = boxRenderer(paths[0][0]);
            const rest = this.renderDiagram(paths.map(x => x.slice(1)).filter(x => x.length>0), boxRenderer, endOfDiagram);
            let shiftAmount = first.w, connections = [];
            if (rest.in.length === 1) {
                shiftAmount += this.config.connLength;
                connections = rest.in.map((val, ix) =>
                    <line key={ix} x1={first.w} y1={0} x2={first.w+this.config.connLength} y2={val} {...this.config.connStrokeProps} />
                );
            }
            else if (rest.in.length > 1) {
                shiftAmount += 2*this.config.connLength;                
                connections = rest.in.map((val, ix) =>
                    <g key={ix}>
                        <line x1={first.w+0.5*this.config.connLength} y1={0} x2={first.w+1.5*this.config.connLength} y2={val} {...this.config.connStrokeProps} />
                        <line x1={first.w+1.5*this.config.connLength} y1={val} x2={first.w+2*this.config.connLength} y2={val} {...this.config.connStrokeProps} />
                    </g>
                );
                connections.push(<line key={rest.in.length} x1={first.w} y1={0} x2={first.w+0.5*this.config.connLength} y2={0} {...this.config.connStrokeProps} />);
            }
            const res = {
                g: <g>
                        {first.g}
                        {connections}
                        <g transform={`translate(${shiftAmount} 0)`}>{rest.g}</g>
                    </g>,
                w: shiftAmount + rest.w,
                h: Math.max(first.h, rest.h),
                d: Math.max(first.d, rest.d),
                in: [0]
            };
            return res;
        }
        else {
            // a branch, more complicated
            const mergePoint = getMergePoint(paths);
            const splittedPaths = splitPaths(paths, mergePoint);
            const groups = groupConnectedPaths(splittedPaths.first);
            const rest = this.renderDiagram(splittedPaths.second, boxRenderer, endOfDiagram);
            const boxes = groups.map(g => this.renderDiagram(g, boxRenderer, rest.w>0 ? false : endOfDiagram));
            // arrange boxes on top of each other and return result
            const totalHeight = boxes.reduce((acc, curr) => acc + curr.h + curr.d, 0) + (boxes.length-1) * this.config.rowGap;
            const needsClosingConnections = rest.w>0 || !endOfDiagram;
            const maxWidth = boxes.reduce((acc, curr) => Math.max(acc, curr.w), 0) + (needsClosingConnections ? 2*this.config.connLength : 0);
            let blockG = [];
            let yShift = -totalHeight/2;
            let inPorts = [];
            for (const box of boxes) {
                yShift += box.h;
                blockG.push(<g key={yShift} transform={`translate(0 ${yShift})`}> 
                    {box.g} 
                    {needsClosingConnections && <line x1={box.w} y1={0} x2={maxWidth-1.5*this.config.connLength} y2={0} {...this.config.connStrokeProps} />}
                    {needsClosingConnections && <line x1={maxWidth-1.5*this.config.connLength} y1={0} x2={maxWidth-0.5*this.config.connLength} y2={-yShift} {...this.config.connStrokeProps} />}
                </g>);
                inPorts.push(box.in.map(x => x+yShift));
                yShift += box.d + this.config.rowGap;
            }
            const res = {
                g: <g>
                        {blockG}
                        <g transform={`translate(${maxWidth} 0)`}>{rest.g}</g>
                        {needsClosingConnections && <line x1={maxWidth-0.5*this.config.connLength} y1={0} x2={maxWidth} y2={0} {...this.config.connStrokeProps} />}
                    </g>,
                w: maxWidth + rest.w,
                h: Math.max(totalHeight/2, rest.h),
                d: Math.max(totalHeight/2, rest.d),
                in: [].concat(...inPorts)
            };
            return res;
        }
    }

    render() {
        if (this.props.pipelineModel) {
            this.config.connStrokeProps["stroke"] = getComputedStyle(document.querySelector('body')).getPropertyValue("--main-fg-color");
            //const rootBox = this.renderDiagram(this.testPaths2, element => this.pipelineBoxRenderer(element));
            const paths = Object.values(this.props.pipelineModel.paths).map(x => x && x.phases ? x.phases : null).filter(x => x);
            const rootBox = this.renderDiagram(paths, element => this.pipelineBoxRenderer(element));
            return <svg width={rootBox.w} height={rootBox.h+rootBox.d}>
                <g transform={`translate(0 ${rootBox.h})`}>
                    {rootBox.g}
                </g>
            </svg>;
        }
        else
            return <></>;
    }

};